export default {
  "visualization": {
    "dashboard": {
      "title": "Dashboards",
      "create": "Create Dashboard",
      "input_placeholder": "Search dashboard in this workspace",
      "search": "Search",
      "amount": "{amount} Dashboards",
      "lastEdited": "Last edited",
      "publish": "Publish",
      "widgets": "Widgets",
      "visualization": "Visualization",
      "textBlock": "Text Block",
      "heading": "Heading",
      "imageUpload": "Image",
      "dynamic_filters": "Dynamic Filters",
      "start": "Start building your dashboard!",
      "chooseWidgets": "Choose widgets from the left pane to add them to your dashboard."
    },
    "actions": {
      "update": "Update",
      "delete": "Delete"
    },
    "form": {
      "title": "Visualization Title",
      "type": "Visualization Type",
      "groupBy": "Column",
      "column": "Column",
      "columnTotals": "Column Totals",
      "columns": "Column(s)",
      "xAxis": "X Axis",
      "yAxis": "Y Axis",
      "xLabel": "X Label",
      "yLabel": "Y Label",
      "name": "Name",
      "horizontal_chart": "Horizontal Chart",
      "stacked_bar_chart": "Stacked Bar Chart",
      "metric": "Metric",
      "description": "Description",
      "maxValue": "Max Value",
      "group": "Group",
      "dataType": "Data Type",
      "orderByColumn": "Order By",
      "sort": "Sort By",
      "comparison": "Comparison",
      "comparisonNone": "None",
      "staticValue": "Static Value",
      "comparisonColumn": "Comparison Column",
      "comparisonValue": "Comparison Value",
      "deltaStyle": "Delta Style",
      "maxValueMode": "Max Value Mode",
      "dynamicColumn": "Dynamic Column",
      "maxValueAgg": "Aggregate",
      "targetValueColumn": "Target Value Column",
      "fetchDescValue": "Fetch Dynamic Value for Description",
      "fetchDescValue.tooltip": "Fetches a value from your data using the selected column and aggregate. Use {{dynamic_value_for_description}} in the description field to display it.",
      "descValueColumn": "Column",
      "conditionalFormatting": "Conditional Formatting",
      "addRule": "Add Rule",
      "noRulesDefined": "No rules defined",
      "and": "and",
      "format": "Format",
      "columnFormats": "Column Formats",
      "headerBackground": "Header Background",
      "headerFontColor": "Header Font Color",
      "showRowNumbers": "Show Row Numbers",
      "hideTitle": "Hide Title",
      "descriptionBelowChart": "Put description below the chart",
      "customQuery": "Custom Query",
      "hidePagination": "Hide Pagination When Single Page",
      "hideHiddenSortColumns": "Hide List of Hidden Sort-by Columns",
      "sortBy": "Sort By",
      "sortAscending": "Ascending",
      "sortDescending": "Descending",
      "sortAddColumn": "Add sort column",
      "sortDisplayColumns": "Display Columns",
      "sortDatasetColumns": "Other Dataset Columns",
      "sortedByHidden": "Sorted by hidden:",
      "sortedAscending": "Sorted ascending",
      "sortedDescending": "Sorted descending",
      "showComparisonValue": "Show Comparison Value",
      "prefix": "Prefix",
      "suffix": "Suffix",
      "valueFormat": "Value Format",
      "decimals": "Decimals",
      "placeholder": {
        "title": "Input a title",
        "metric": "Select a metric",
        "column": "Select a column",
        "type": "Select a type",
        "label": "Input a label",
        "description": "Input a description",
        "direction": "Select a direction",
        "maxValue": "Input a maximum value",
        "maxValueAgg": "Aggregate",
        "comparisonValue": "Enter value",
        "format": "Select format"
      },
      "validation": {
        "xAxis": "Please select an X axis",
        "yAxis": "Please select a Y axis",
        "column": "Please select a column",
        "metric": "Please select a metric",
        "columns": "Please select the columns",
        "comparisonValue": "Please enter a comparison value",
        "comparisonColumn": "Please select a comparison column",
        "maxValue": "Please provide a max value",
        "targetValueColumn": "Please select a target value column"
      }
    },
    "create_modal_dialog": {
      "title": "Create new visualization",
      "submit_button": "Create visualization"
    },
    "update_modal_dialog": {
      "title": "Edit visualization",
      "for_dataset": "for",
      "submit_button": "Update visualization"
    },
    "delete_modal_dialog": {
      "title": "Delete visualization {name} ?",
      "description": "Are you sure you want to delete this visualization?",
      "submit_button": "Delete visualization"
    }
  }
};
